import { useTranslation } from "react-i18next";
import { UserCircle, CalendarCheck, Stethoscope, ClipboardCheck, RefreshCcw } from "lucide-react";

const steps = [
  { key: "intake", icon: UserCircle },
  { key: "book", icon: CalendarCheck },
  { key: "review", icon: Stethoscope },
  { key: "plan", icon: ClipboardCheck },
  { key: "followup", icon: RefreshCcw },
] as const;

export function HowItWorksPage() {
  const { t } = useTranslation();
  return (
    <div className="container-app py-16 lg:py-20">
      <h1 className="text-4xl font-semibold text-charcoal-900">{t("howItWorks.title")}</h1>
      <p className="mt-3 max-w-2xl text-lg text-charcoal-600">{t("howItWorks.subtitle")}</p>

      <ol className="mt-14 space-y-8 border-s-2 border-primary-100 ps-8">
        {steps.map((s, idx) => (
          <li key={s.key} className="relative">
            <span className="absolute -start-[2.55rem] flex h-9 w-9 items-center justify-center rounded-full bg-primary-600 text-sm font-semibold text-white">
              {idx + 1}
            </span>
            <div className="flex items-center gap-2.5">
              <s.icon className="h-5 w-5 text-primary-700" />
              <h3 className="text-lg font-semibold text-charcoal-800">{t(`howItWorks.steps.${s.key}.title`)}</h3>
            </div>
            <p className="mt-1.5 text-charcoal-500">{t(`howItWorks.steps.${s.key}.body`)}</p>
          </li>
        ))}
      </ol>
    </div>
  );
}
